import { GD } from "src/GD";

export class PayoutsService {
	constructor() {
		GD.REQ_PAYOUTS.listener = async () => this.getPayouts();
	}

	async getPayouts(): Promise<IAPIResponse<IPayout[]>> {
		let res: IAPIResponse<IPayout[]> = { error: { code: -1, message: "No data" } };

		// res = await GD.REQ_API.request({
		// 	method: "clients/list",
		// 	data: {
		// 		acquirer_id: req.acquirerId,
		// 		terminal_id: req.terminalId,
		// 		channel_id: req.channelId,
		// 		project_id: (await GD.REQ_CURRENT_PROJECT.request())?.id,
		// 	},
		// });

		// No payouts endpoint is wired yet. Never present demo financial data as real.
		const cards: IPayout[] = [];

		res = {
			data: cards,
		};

		return res;
	}
}
